import axios from 'axios';
import BaseUrl from '../util/BaseUrl';

const API_URL = BaseUrl.baseUrl+"api/point-request";

const getAllPointRequestPages = async (page, size, token) => {
    try {
      const response = await axios.get(API_URL, {
        params: {
          page: page,
          size: size,
        },
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
      return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data.message : 'Failed to getting Point Requests');
    }
};

const getPointRequestById = async (id, token) => {
    try {
        const response = await axios.get(`${API_URL}/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data.message : 'Failed to getting Point Request');
    }
};

const rejectPointRequest = async (id, comment, token) => {
    try {
        const response = await axios.patch(`${API_URL}/${id}/reject`,{}, {
                params: {
                    comment: comment
                },
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data.message : 'Failed to Reject Point Request');
    }
};


const verifyPointRequest = async (id, token) => {
    try {
        const response = await axios.patch(`${API_URL}/${id}/verify`,{}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data.message : 'Failed to Verify Point Request');
    }
};

const deletePointRequest = async (id, token) => {
    try {
        const response = await axios.delete(`${API_URL}/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data.message : 'Failed to Delete Point Request');
    }
};


const PointRequestService = {
    getAllPointRequestPages,
    getPointRequestById,
    rejectPointRequest,
    verifyPointRequest,
    deletePointRequest
};

export default PointRequestService;